module.exports = __webpack_public_path__ + "img/banner-TV-1__lg.34a3a737.jpg";